import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import ArticlePublicationStatus from "../../../../articles/components/ArticlePublicationStatus/ArticlePublicationStatus";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";

export default function useUpcomingTitlesColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			Header: t("title", "title"),
			collapsing: true,
			Cell: ({ row }) => {
				return (
					<Flex justifyContent="flex-start">
						<div style={{ marginRight: "1em", height: 45, width: 45 }}>
							<CoverImage thumb rounded data={row} size={45} style={{ margin: "0 auto" }} />
						</div>

						<div>{row.name}</div>
					</Flex>
				);
			},
		},
		{
			id: "isbn",
			Header: t("ISBN"),
			collapsing: true,
		},
		{
			id: "publicationStatus",
			Header: t("publicationStatus", "Publication status"),
			collapsing: true,
			Cell: ({ row }) => <ArticlePublicationStatus article={row} />,
		},
		{
			id: "releaseDate",
			Header: t("releaseDate", "Release date"),
		},
	];
}
